// @flow
import { createSelector } from 'reselect';

export const cardsSelector = createSelector(
  state => state.cards,
  (cards: $ElementType<ReduxState, 'cards'>): $ElementType<ReduxState, 'cards'> => cards || {}
);

export const cardsListSelector = createSelector(
  cardsSelector,
  (cards: $ElementType<ReduxState, 'cards'>): List => Object.keys(cards)
);
